/* Presentation only. Shared pricing.js owns purchase and inventory checks. */
(() => {
  'use strict';
  const form = document.querySelector('[data-product-detail-form]');
  if (!form) return;
  const radios = [...form.querySelectorAll('[name=set]')];
  function updateSet() {
    const count = radios.find(radio => radio.checked)?.value;
    if (!['1', '2', '3'].includes(count)) return;
    document.querySelector('#set-caption').textContent = count + (count === '1' ? ' bottle.' : ' bottles.') + ' Same mist.';
    const record = [...form.querySelectorAll('[data-pack-price]')].find(option => option.dataset.packPrice === count);
    if (record?.dataset.variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', record.dataset.variantId);
      window.history.replaceState(null, '', url);
    }
  }
  radios.forEach(radio => radio.addEventListener('change', updateSet));
  updateSet();

  // Browsing photos must never select a pack or alter its price or availability.
  const image = document.querySelector('#product-image');
  const mobile = document.querySelector('#product-image-mobile');
  const controls = document.querySelector('.pdp-thumbnails');
  if (!image || !mobile || !controls) return;
  const buttons = [...controls.querySelectorAll('[data-gallery-image]')];
  function showImage(index) {
    const button = buttons[index];
    mobile.srcset = button.dataset.mobile;
    image.src = button.dataset.desktop;
    image.alt = button.dataset.alt;
    document.querySelector('#pdp-image-count').textContent = String(index + 1).padStart(2, '0') + ' / 04 · ' + button.dataset.caption;
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }
  buttons.forEach((button, index) => {
    button.addEventListener('click', () => showImage(index));
    button.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = buttons.length - 1;
      else return;
      event.preventDefault();
      showImage(next);
      buttons[next].focus();
    });
  });
  controls.hidden = false;
})();

/* Presentation enhancements delegate all buying to the existing commerce engine. */
(() => {
  'use strict';
  const bar = document.querySelector('.pdp-sticky-buy');
  const form = document.querySelector('[data-product-detail-form]');
  if (!bar || !form) return;
  const buy = form.querySelector('#add-to-cart');
  const quantity = form.querySelector('#set-quantity');
  const price = form.querySelector('#set-price');
  const stickyBuy = bar.querySelector('[data-sticky-add]');
  const steps = [...form.querySelectorAll('[data-quantity-step]')];
  const nav = document.querySelector('.pdp-section-nav');
  const links = [...nav.querySelectorAll('a')];
  const sections = links.map(link => document.querySelector(link.getAttribute('href')));
  function sync() {
    const selected = form.querySelector('[name=set]:checked');
    const count = selected?.value || '1';
    bar.querySelector('[data-sticky-set]').textContent = `${count} ${count === '1' ? 'bottle' : 'bottles'} / set · Quantity: ${quantity.value || '—'}`;
    bar.querySelector('[data-sticky-price]').textContent = price.textContent;
    stickyBuy.textContent = buy.textContent;
    stickyBuy.disabled = buy.disabled;
    const value = Number(quantity.value);
    const min = Number(quantity.min) || 1;
    const increment = Number(quantity.step) || 1;
    const max = quantity.max === '' ? Infinity : Number(quantity.max);
    steps.forEach(button => {
      button.hidden = false;
      const direction = Number(button.dataset.quantityStep);
      const disabled = quantity.disabled || !Number.isFinite(value) || (direction < 0 ? value <= min : value + increment > max);
      if (button.disabled !== disabled) button.disabled = disabled;
    });
  }
  steps.forEach(button => button.addEventListener('click', () => {
    if (quantity.disabled) return;
    if (Number(button.dataset.quantityStep) < 0) quantity.stepDown(); else quantity.stepUp();
    quantity.dispatchEvent(new Event('input', {bubbles:true}));
    quantity.dispatchEvent(new Event('change', {bubbles:true}));
  }));
  stickyBuy.addEventListener('click', () => {
    if (buy.disabled) return;
    if (!form.checkValidity()) {
      form.scrollIntoView({block:'center'});
      form.reportValidity();
      return;
    }
    buy.click();
  });
  // Bring the original commerce result into view, including validation/server errors.
  const feedback = form.querySelector('#cart-feedback');
  new MutationObserver(() => {
    if (feedback.textContent.trim() && !bar.hidden) {
      feedback.scrollIntoView({block:'center'});
      feedback.focus({preventScroll:true});
    }
  }).observe(feedback, {childList:true,subtree:true,characterData:true});
  new MutationObserver(sync).observe(form, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','min','max','step']});
  form.addEventListener('input', sync);
  form.addEventListener('change', () => queueMicrotask(sync));
  let pending = false;
  function updatePosition() {
    pending = false;
    const hidden = form.getBoundingClientRect().bottom > 0;
    if (hidden && bar.contains(document.activeElement)) buy.focus({preventScroll:true});
    bar.hidden = hidden;
    document.documentElement.classList.toggle('pdp-has-sticky', !hidden);
    let active = -1;
    sections.forEach((section, i) => { if (section.getBoundingClientRect().top <= 100) active = i; });
    links.forEach((link, i) => {
      if (i === active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current');
    });
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(updatePosition); } }
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  sync();
  updatePosition();
})();
